import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { InteractionQuestion } from '../../../../models/interactions.model';
import { HighlightVariablesPipe } from '../../../../pipes/highlight-variables.pipe';
import { TtsPlayerService } from '../../../../services/tts-player.service';

@Component({
  selector: 'app-question-list-item',
  imports: [
    CdkDrag,
    CdkDragHandle,
    MatIcon,
    MatIconButton,
    MatTooltip,
    HighlightVariablesPipe,
  ],
  templateUrl: './question-list-item.component.html',
  styleUrl: './question-list-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionListItemComponent {
  private readonly _ttsPlayer = inject(TtsPlayerService);

  public readonly data = input.required<InteractionQuestion>();
  public readonly index = input<number>();

  public readonly selected = input(false, { transform: booleanAttribute });
  public readonly draggable = input(false, { transform: booleanAttribute });

  public readonly selectionChange = output();

  protected readonly isTtsPlaying = computed(
    () =>
      this._ttsPlayer.isPlaying() &&
      this._ttsPlayer.currentTtsId() === `question_${this.data()._id}`
  );

  protected handleTtsPlayback(event: MouseEvent): void {
    event.stopPropagation();
    this._ttsPlayer.play(this.data().value, `question_${this.data()._id}`);
  }
}
